import {
  ActionButton,
  ActionsGroup,
  Chip,
  Panel,
  Table,
  TableChild
} from '@elotech/components';
import React, { useState } from 'react';

import {
  UsuarioDocumento,
  podeReenviar,
  situacaoColor,
  situacaoLabel
} from './verificacaoDocumentos';

type Props = {
  documentos: UsuarioDocumento[];
  onReenviar(): void;
};

const SolicitacaoDocumentosTable = ({ documentos, onReenviar }: Props) => {
  const [expandedIndexes, setExpandedIndexes] = useState<number[]>([]);

  const onToggleMotivo = (index: number) => {
    setExpandedIndexes(prev => (prev.includes(index) ? [] : [index]));
  };

  return (
    <Panel isTable>
      <Table
        values={documentos}
        keyExtractor={usuarioDocumento => usuarioDocumento.id}
        renderInnerComponent={(usuarioDocumento, index) =>
          expandedIndexes.includes(index) && (
            <TableChild>
              <b>Motivo: </b>
              {usuarioDocumento.motivoReenvio}
            </TableChild>
          )
        }
      >
        <Table.Column<UsuarioDocumento>
          header="Documento"
          value={usuarioDocumento =>
            usuarioDocumento.documentoValidacaoNivel.documentoSolicitado
          }
        />
        <Table.Column<UsuarioDocumento>
          header="Situação"
          value={usuarioDocumento => (
            <Chip
              inline
              value={
                situacaoLabel[usuarioDocumento.situacao] ||
                usuarioDocumento.situacao
              }
              color={situacaoColor[usuarioDocumento.situacao]}
            />
          )}
        />
        <Table.Column<UsuarioDocumento>
          header=""
          value={(usuarioDocumento, index) => (
            <ActionsGroup>
              {podeReenviar(usuarioDocumento.situacao) &&
                usuarioDocumento.motivoReenvio && (
                  <ActionButton
                    key={`motivo-${usuarioDocumento.id}`}
                    icon="eye"
                    label="Visualizar motivo"
                    onClick={() => onToggleMotivo(index)}
                  />
                )}
              {podeReenviar(usuarioDocumento.situacao) && (
                <ActionButton
                  key={`reenviar-${usuarioDocumento.id}`}
                  icon="paper-plane"
                  label="Reenviar"
                  onClick={onReenviar}
                />
              )}
            </ActionsGroup>
          )}
        />
      </Table>
    </Panel>
  );
};

export default SolicitacaoDocumentosTable;
